import layout from '@/layout'

const meta = {
  auth: true,
}

export default {
  path: '/custManagement',
  component: layout,
  children: ((pre) => [
    {
      path: 'cust/custInfo',
      name: `${pre}info`,
      meta: {
        ...meta,
        cache: true,
        title: '客户资料管理',
        head: true,
        funcID: 'T000601',
        PID: 'T00',
      },
      component: () => import('@/views/digital/customerManage/info'),
    },
    {
      path: 'cust/custInfo/edit/:custCode',
      name: `${pre}info-edit`,
      meta: {
        ...meta,
        cache: true,
        title: '客户资料管理编辑',
        funcID: 'T000601',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/customerManage/info/components/edit'),
    },
    {
      path: 'cust/custInfo/v2/:pageType/:custCode?',
      name: `${pre}info-v2-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { custNo = '' } = $route.query || {}
          if (!custNo) return '客户资料管理'
          return `客户资料管理 | ${custNo}`
        },
        funcID: 'T000601',
        PID: 'T00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0' },
          body: { class: 'd-flex pt-0 mb-0' },
        },
      },
      component: () => import('@/views/digital/customerManage/info/detail'),
    },
    {
      path: 'cust/custInfo/:custCode',
      name: `${pre}info-detail`,
      meta: {
        ...meta,
        cache: true,
        title: '客户资料管理详情',
        funcID: 'T000601',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/customerManage/info/components/detail'),
    },
    {
      path: 'brand',
      name: `${pre}brand`,
      meta: {
        ...meta,
        cache: true,
        title: '品牌信息维护',
        head: true,
        funcID: 'T000602',
        PID: 'T00',
      },
      component: () => import('@/views/digital/customerManage/brand'),
    },
    {
      path: 'custBizTeamSet',
      name: `${pre}custBizTeamSet`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000603',
        PID: 'T00',
      },
      component: () => import('@/views/digital/customerManage/custBizTeamSet'),
    },
    {
      path: 'myCust',
      name: `${pre}myCust`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000604',
        PID: 'T00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0' },
          body: { class: 'pt-0' },
        },
      },
      component: () => import('@/views/digital/customerManage/myCust'),
    },
    {
      path: 'myCust/:custCode',
      name: `${pre}myCust-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { custNo = '' } = $route.query || {}
          if (!custNo) return '客户信息'
          return `客户信息 | ${custNo}`
        },
        funcID: 'T000604',
        PID: 'T00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0' },
          body: { class: 'pt-0' },
        },
      },
      component: () => import('@/views/digital/customerManage/myCust/detail'),
    },
    {
      path: 'selectionTracking',
      name: `${pre}selectionTracking`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000605',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/customerManage/selectionTracking'),
    },
    {
      path: 'selectionTracking/:pageType/:devTrackingCode?',
      name: `${pre}selectionTracking-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { devTrackingNo } = $route.query || {}
          return `客户选品跟踪 | ${devTrackingNo || 'New'}`
        },
        head: true,
        funcID: 'T000605',
        PID: 'T00',
        pageConfig: { layout: { class: 'bg-transparent p-0' } },
      },
      component: () =>
        import('@/views/digital/customerManage/selectionTracking/detail'),
    },
    {
      path: 'riskCheck',
      name: `${pre}riskCheck`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000606',
        PID: 'T00',
      },
      component: () => import('@/views/digital/customerManage/riskCheck'),
    },
    {
      path: 'proofingRecord',
      name: `${pre}proofingRecord`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000607',
        PID: 'T00',
      },
      component: () => import('@/views/digital/customerManage/proofingRecord'),
    },
    {
      path: 'proofingRecord/:pageType/:proofingCode?',
      name: `${pre}proofingRecord-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { proofingNo } = $route.query || {}
          return `客户打样记录 | ${proofingNo || 'New'}`
        },
        head: true,
        funcID: 'T000607',
        PID: 'T00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0' },
          body: { class: 'd-flex' },
        },
      },
      component: () =>
        import('@/views/digital/customerManage/proofingRecord/detail'),
    },
    {
      path: 'sendSample',
      name: `${pre}sendSample`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000608',
        PID: 'T00',
      },
      component: () => import('@/views/digital/customerManage/sendSample'),
    },
    {
      path: 'sendSample/:pageType/:sendSampleCode?',
      name: `${pre}sendSample-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { sendSampleNo } = $route.query || {}
          return `客户寄祥记录 | ${sendSampleNo || 'New'}`
        },
        head: true,
        funcID: 'T000608',
        PID: 'T00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0' },
          body: { class: 'd-flex' },
        },
      },
      component: () =>
        import('@/views/digital/customerManage/sendSample/detail'),
    },
    {
      path: 'customerQuotation',
      name: `${pre}customerQuotation`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000610',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/customerManage/customerQuotation'),
    },
    {
      path: 'customerQuotation/:pageType/:quotationCode?',
      name: `${pre}customerQuotation-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { quotationNo } = $route.query || {}
          return `客户报价单 | ${quotationNo || 'New'}`
        },
        head: true,
        funcID: 'T000610',
        PID: 'T00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0' },
          body: { class: 'd-flex' },
        },
      },
      component: () =>
        import('@/views/digital/customerManage/customerQuotation/detail'),
    },
    {
      path: 'selectionQuotation',
      name: `${pre}selectionQuotation`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000611',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/customerManage/selectionQuotation'),
    },
    {
      path: 'selectionQuotation/:pageType/:devTrackingQuotationNo?',
      name: `${pre}selectionQuotation-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { devTrackingQuotationNo } = $route.params || {}
          return `客户选品报价记录 | ${devTrackingQuotationNo || 'New'}`
        },
        head: true,
        funcID: 'T000611',
        PID: 'T00',
        // pageConfig: { layout: { class: 'bg-transparent p-0' } },
      },
      component: () =>
        import('@/views/digital/customerManage/selectionQuotation/detail'),
    },
    {
      path: 'cust/custAudit',
      name: `${pre}custAudit`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000612',
        PID: 'T00',
      },
      component: () => import('@/views/digital/customerManage/custAudit'),
    },
    {
      path: 'costSector',
      name: `${pre}costSector`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000613',
        PID: 'T00',
      },
      component: () => import('@/views/digital/customerManage/costSector'),
    },
  ])('customerManage-'),
}
